<template>
  <RowList :products="products" title="相關推薦" curationGuid="recommend" />
</template>

<script>
import RowList from '@/components/layout/rowList.vue'
export default {
  name: 'RelateCommend',
  components: {
    RowList,
  },

  data() {
    return {
      products: [],
    }
  },
  mounted: function() {
    if (localStorage.getItem('source') !== 'e7g') this.loadData()
  },
  methods: {
    loadData: function() {
      const id = this.$route.params.id
      const self = this
      api.getRecommendProducts(id).then(function(res) {
        self.products = res.data
      })
    },
  },
}
</script>

<style scoped lang="scss">
.section {
  background-color: #ffffff;
  padding: 16px 0;
}
</style>
